module.exports = __webpack_public_path__ + "img/theme1.b2fba971.png";